import { jsx } from "react/jsx-runtime";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { validateTidalLicense } from "../../base/index.js";
function PictureAsPdf(props) {
  return /* @__PURE__ */ jsx(
    PictureAsPdfIcon,
    {
      "data-testid": "PictureAsPdf",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PictureAsPdf",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
PictureAsPdf.tidalIconMeta = {
  categories: "fileActions",
  name: "PictureAsPdf"
};
validateTidalLicense();
export {
  PictureAsPdf
};
//# sourceMappingURL=PictureAsPdf.js.map
